import type { JSX, PropsWithChildren } from 'react';

import { StarterDashboardBannerStateContextProvider } from './context';
import { useBannerState } from './hook';

export function StarterDashboardBannerStateProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element | null {
	const bannerState = useBannerState();

	return (
		<StarterDashboardBannerStateContextProvider {...bannerState}>{children}</StarterDashboardBannerStateContextProvider>
	);
}
